import styled from 'styled-components';

export const ZipcodeConditionStyled = styled.div`
  .post-tags {
    max-height: 200px;
  }
  .Polaris-Tag {
    padding-inline-end: 0;
  }
  .Polaris-Tag__Button > div {
    height: 100%;
    line-height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .Polaris-Tag__TagText {
    white-space: pre-wrap;
  }
`;
